import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function News() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Stay updated with the latest hotel news and developments on First-Class.com. Discover new openings, renovations, and luxury accommodations'
          }
        />
        <title>Hotel News: Stay Updated on Hospitality Industry News</title>
      </Head>
      <ArticlesList subtype="News" type="Hotels" />
    </>
  );
}

export default withLayout(News, true);
